<template>
  <section class="page">
    <h2>My Tech Stack</h2>
    <div class="tech-list">
      <fancy-button title="Node.js" class="stack" href="https://www.nodejs.org"><img alt="Node logo" src="https://nodejs.org/static/images/logos/nodejs-new-white.svg" /></fancy-button>
      <fancy-button title="Firebase" class="stack" href="https://www.firebase.com"><img alt="Firebase logo" src="@/assets/img/firebase-logo.png"/></fancy-button>
      <fancy-button title="Vue" class="stack" href="https://www.vuejs.org"><img alt="Vue logo" src="https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg" /></fancy-button>
      <fancy-button title="React" class="stack" href="https://www.reactjs.org"><img alt="React logo" src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" /></fancy-button>
      <fancy-button title="MySQL" class="stack" href="https://www.mysql.com"><img alt="MySQL logo" src="@/assets/img/mysql-logo.svg" /></fancy-button>
      <fancy-button title="Express Framework" class="stack" href="https://www.expressjs.com"><img alt="Express logo" src="@/assets/img/express-logo.png" /></fancy-button>
    </div>
  </section>
</template>

<script>
import FancyButton from '@/components/FancyButton.vue'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MyTechStack',
  components: {
    'fancy-button': FancyButton
  },
  setup() {
    
  },
})
</script>


<style scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stack img {
  height: 50px;
  width: 175px;
  object-fit: contain
}

.tech-list {
  display: flex;
  gap: 1rem;
  flex-direction: row;
}
</style>
